"use client";

import { LanguageContext } from "@/context/languageContext";
import styles from "@/styles/modules/components/events/eventsList.module.scss";
import { Event } from "@/types/wordpress";
import { translate } from "@/utils/translate";
import Image from "next/image";
import Link from "next/link";
import { useContext } from "react";

interface EventsListProps {
  events: Event[];
}

export default function EventsList({ events }: EventsListProps) {
  const { language } = useContext(LanguageContext);

  return (
    <section className={styles.eventsList}>
      <div className={styles.eventsListContainer}>
        {events.map((item, i) => (
          <article key={i}>
            {item.featuredImage && (
              <div className={styles.image}>
                <Link href={`/${language}/events/${item.slug}`}>
                  <Image
                    alt={item.featuredImage.node.altText || "Imperial Riding School"}
                    src={item.featuredImage.node.link}
                    width={item.featuredImage.node.mediaDetails.width}
                    height={item.featuredImage.node.mediaDetails.height}
                  />
                </Link>
              </div>
            )}
            <div className={styles.info}>
              <div className={styles.text}>
                <h3>{item.title}</h3>
                <p>{item.eventsContent.date}</p>
              </div>
              <div className={styles.links}>
                <Link href={`/${language}/events/${item.slug}`}>
                  {translate["findOutMore"][language]}
                </Link>
                {item.contentFields.button && (
                  <a href={item.contentFields.button.url} target={item.contentFields.button.target}>
                    {item.contentFields.button.title}
                  </a>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section >
  );
}
